export interface IBranch {
  workspace: String | Object
  type: String
  name: String
  taxNumber: String
  website: String
  address: String
  logoUrl: String
  status: Number
  workday: Number
  currency: String
}

const rulesBranch = {
  name: 'required',
  taxNumber: 'required',
  website: 'required',
  address: 'required'
}

const initBranch = {
  name: '',
  taxNumber: '',
  website: '',
  address: ''
}

export interface ICompanyGroup {
  group: string
  name: string
}

export interface ICompanyUser {
  workspace: String | Object
  user: String
  status: Number
  company: String
  group: String
  fullName: String
  address: String
  email: String
  jobTitle: String
}

const initCompanyUser = {
  id: '',
  _id: '',
  registerBy: 'email',
  group: '',
  fullName: '',
  address: '',
  phone: {
    code: '+84',
    phone: '',
    countryCode: 'Vietnam +84'
  },
  jobTitle: '',
  email: ''
}

export default {
  rulesBranch,
  initBranch,
  initCompanyUser
}
